export const webview = {
  webviewContent: 'To jest zewnętrzny adres URL i zostanie otwarty w nowym oknie. Otworzyć?',
  webviewButtonOpenTitle: 'Otwórz',
  webviewButtonCopyTitle: 'Kopiuj URL',
  webviewButtonOpenAgainTitle: 'Otwórz ponownie',
  notifications: {
    urlCopied: 'URL skopiowany!'
  }
}
